/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { adoWorkItemStateSummarySchema } from './adoWorkItemStateSummarySchema';

export const adoWorkItemTypeSummarySchema = z.object({
  id: z.string(),
  name: z.string(),
  get states() {
    return z.array(adoWorkItemStateSummarySchema);
  },
  statesUnavailable: z.boolean(),
});
